// agent group slice
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface CallCampaign {
  id: string;
  name: string;
}

export interface CallCampaignState {
  callCampaigns: CallCampaign[];
  loading: boolean;
  error: string | null;
}

export const callCampaignInitialState: CallCampaignState = {
  callCampaigns: [],
  loading: false,
  error: null,
};

const callCampaignSlice = createSlice({
  name: 'callCampaign',
  initialState: callCampaignInitialState,
  reducers: {
    fetchCallCampaign(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    fetchCallCampaignSuccess(state, action: PayloadAction<CallCampaign[]>) {
      state.loading = false;
      state.callCampaigns = action.payload;
    },
    fetchCallCampaignFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCallCampaign,
  fetchCallCampaignSuccess,
  fetchCallCampaignFailure,
} = callCampaignSlice.actions;

export default callCampaignSlice.reducer;
